/**
 * @author: lv.chen
 * @date: 2025/4/28
 * @desc: Technical模块组件
 */
import React from 'react';
import classnames from 'classnames';
import { formatDateStr } from '@gp/utils/common';
import GeneralTagList from '@gp/components/GeneralTagList';
import { PIPELINE_PROJECT_TECHNICAL_MODULE_CFG_MAPPINGS } from '../../const';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface ITechnicalModuleProps extends IBaseProps {
  module: IPipelineProjectTechnicalModule;
}

const TechnicalModule: React.FC<ITechnicalModuleProps> = (props) => {
  const { style, className, module } = props;
  const { module: moduleId, update_time: moduleUpdateTime, list: moduleTechnicals } = module || {};
  const { icon, title } = PIPELINE_PROJECT_TECHNICAL_MODULE_CFG_MAPPINGS[moduleId] || {};
  const formatedModuleUpdateTime = formatDateStr(moduleUpdateTime);
  const isNoData = !Array.isArray(moduleTechnicals) || !moduleTechnicals.length;
  const formatedModuleTechnicals = isNoData ? [] : moduleTechnicals?.map((moduleTechnical) => moduleTechnical?.tag);

  return (
    <div style={style} className={classnames('dbg-pipeline-project-details-technical-module', className)}>
      <div className="dbg-pipeline-project-details-technical-module__header">
        <img className="dbg-pipeline-project-details-technical-module__icon" src={icon} title="" />
        <span className="dbg-pipeline-project-details-technical-module__title">{title}</span>
        {!!formatedModuleUpdateTime && (
          <span className="dbg-pipeline-project-details-technical-module__update-time">
            Update on {formatedModuleUpdateTime}
          </span>
        )}
      </div>
      <div className="dbg-pipeline-project-details-technical-module__body">
        {isNoData && <span className="dbg-pipeline-project-details-technical-module__no-data-text">No Data</span>}
        <GeneralTagList
          className="dbg-pipeline-project-details-technical-module__technical-list"
          tags={formatedModuleTechnicals}
        />
      </div>
    </div>
  );
};

export default TechnicalModule;
